import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './style.module.css';

const Alert = ({ alerts }) => {
  // Use a Set to keep track of unique alert messages
  const uniqueAlerts = new Set();

  return (
    <>
      {alerts !== null &&
        alerts.length > 0 &&
        alerts.map((alert) => {
          // Use the alert message as a key to check uniqueness
          const key = alert.msg;
          const type = alert.alertType;
          // Check if the alert message is already displayed
          if (uniqueAlerts.has(key)) {
            return null; // Skip rendering duplicate alert
          }

          // Add the alert message to the Set to track uniqueness
          uniqueAlerts.add(key);
          if(type === "401"){
            return (
              <div key={alert.id} className={styles.modalOverlay}>
                <div className={`${styles.modalContent} ${styles.alertModal}`}>
                  {alert.msg}
                </div>
              </div>
            );
          }
          else{
            return(
            <div key={alert.id} className={`alert alert-${alert.alertType}`}>
              {alert.msg}
            </div>
            )
          }
          
        })}
    </>
  );
};

Alert.propTypes = {
  alerts: PropTypes.array.isRequired,
};

// Fetching state to props
const mapStateToProps = (state) => ({
  alerts: state.alerts,
});

export default connect(mapStateToProps)(Alert);
